 import UserAccount from './UserAccount.mjs';
import { showElement, hideElement, query } from '../utils.mjs';
import WindCreekClient from "./WindCreekClient.mjs";

UserAccount.windCreekClient = new WindCreekClient();

if (query('[data-forgot-password-component]')) {
  let forgotPasswordForm = document.querySelector('[data-forgot-password-form]');
  let resultMessageText = document.querySelector('[data-forgot-password-result-message-text]');

  forgotPasswordForm.addEventListener('submit', event => {
    event.preventDefault();

    hideElement('[data-forgot-password-result-message]');
    hideElement('[data-forgot-password-error-message]');
    resultMessageText.textContent = '';

    let formData = new FormData(event.target);
    let email = formData.get('email').trim();

    forgotPasswordForm.classList.add('loading-animation');
    UserAccount.forgotPassword(email)
      .then(result => {
        resultMessageText.innerText = result?.message ?? 'We received your password reset request. If your email address is valid, we will send you a password reset link.';
        showElement('[data-forgot-password-result-message]');
        forgotPasswordForm.classList.remove('loading-animation');
        //forgotPasswordForm.querySelector('[type="submit"]').disabled = true;
      })
      .catch(error => {
        showElement('[data-forgot-password-error-message]');
        forgotPasswordForm.classList.remove('loading-animation');
        console.log('error occurred during password reset');
        console.error(error);
        newrelic.noticeError(error);
      });
  });
}
